<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-3">
        <h3 class="font-weight-bolder mt-3">Medical Documents</h3>
      </div>
      <div class="col col-sm-2 pt-3">
        <AddMedical v-if="(isDesignatedManning || isPrincipalStaff) && !guest"></AddMedical>
      </div>
      <div class="col-sm-5 offset-2">
        <div class="form-group form-row text-small mt-3">
          <label class="col col-sm-6 col-form-label font-weight-bolder text-right" for="medicaldoc">
            Select Medical Documents:
          </label>
          <div class="col col-sm-5">
            <select class="form-control form-control-xs" id="medicaldoc"
                    v-model="medicalId"
                    @change="updateMedicalList"
            >
              <option :value="''">ALL</option>
              <option v-for="medicalKey in medicalKeys"
                      :key="medicalKey.id"
                      :value="medicalKey.id"
              >{{ medicalKey.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col col-sm-12">
        <MedicalNavigation></MedicalNavigation>
      </div>

      <div class="col-sm-12">
        <table class="table table-sm table-hover table-bordered text-small text-center"
               style="border-color: lightgray;">
          <thead class="bg-lightgray">
          <tr>
            <th :class="{'col-index': !printMultipleParams.active}">
              <input type="checkbox"
                     v-if="printMultipleParams.active"
                     @change="selectDocuments"
                     :checked="allMedicalSelected"
              >
              #
            </th>
            <th width="21%">Medical Type</th>
            <th width="15%">Clinic</th>
            <th width="7%">Fitness Date</th>
            <th width="7%">Diagnosis</th>
            <th width="6%">HBA Test</th>
            <th width="10%">Recommendation</th>
            <th width="auto">Remarks</th>
            <th width="7%">Issued Date</th>
            <th width="7%">Expiry Date</th>
            <th width="10%">Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crewMedical, index) in crewMedicals" :key="crewMedical.id"
                :class="{'bg-success' :
                          (crewMedical.id && printMultipleParams.selectedCrewDocuments.medicals.includes(crewMedical.id)) && printMultipleParams.active}"
            >
              <td class="align-middle">
                <input type="checkbox" name="crew-document-selection"
                       v-if="printMultipleParams.active && crewMedical.hasFile"
                       :value="crewMedical.id"
                       v-model="printMultipleParams.selectedCrewDocuments.medicals"
                >
                {{ index + 1 }}
              </td>
              <td class="align-middle">{{ crewMedical.type }}</td>
              <td class="align-middle">{{ crewMedical.clinic ? crewMedical.clinic : crewMedical.other_clinic }}</td>
              <td class="align-middle">{{ crewMedical.fitness_date || '' | moment('D MMM YYYY') }}</td>
              <td class="align-middle">{{ crewMedical.diagnosis || '' }}</td>
              <td class="align-middle"> {{ crewMedical.hba_test ? 'YES' : 'NO' }}</td>
              <td class="align-middle">{{ crewMedical.recommendation || '' }}</td>
              <td class="align-middle">{{ crewMedical.remarks || '' }}</td>
              <td class="align-middle" v-if="crewMedical.issued_date">
                {{ crewMedical.issued_date | moment('D MMM YYYY') }}
              </td>
              <td class="align-middle" v-else></td>
              <td class="align-middle">{{ crewMedical.expiry_date | moment('D MMM YYYY') }}</td>
              <td class="align-middle">
                <button class="btn btn-sm btn-xs btn-outline-info"
                        data-toggle="modal"
                        data-target="#view-crew-medical"
                        v-if="crewMedical.id"
                        @click="updateCrewMedicalModal(crewMedical)">
                  <span class="fas fa-file-alt"></span>
                  View
                </button>
                <template v-if="crew.active == 1 || isSystemAdmin">
                  <button class="btn btn-sm btn-xs btn-outline-danger ml-1"
                          v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline"
                          @click="confirmDeleteCrewMedical(crewMedical.id)"
                  >
                    <span class="fas fa-ban"></span>
                    Delete
                  </button>
                </template>
              </td>

            </tr>

          </template>

          </tbody>
        </table>
      </div>

            <div class="modal fade px-2" id="view-crew-medical" tabindex="-1" role="dialog" aria-labelledby="view-crew-medical-title" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-medical-custom" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="view">View Medical Record</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                    id="close-update-crew-medical"
                                    @click="editable = false"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body text-small">
                            <div class="row">
                                <form class="col-sm-4" @submit.prevent="confirmUpdateCrewMedical">
                                    <div class="form-group">
                                        <table class="col-table-2 table-sm w-100">

                      <tr :class="{'has-error': crewMedicalError.document_id}">
                        <th>
                          <label class="font-weight-bolder text-left form-label-sm"
                                 for="document_id"
                          >
                            Medical Type:
                          </label>
                        </th>
                        <td>
                          <select id="document_id" required
                                  :disabled="!editable"
                                  class="form-control form-control-sm"
                                  v-model="crewMedical.document_id"
                          >
                            <option :value="''">--- Select Type ---</option>
                            <option v-for="medicalKey in medicalKeys" :key="medicalKey.id"
                                    :value="medicalKey.id"
                            >{{ medicalKey.name }}
                            </option>
                          </select>
                          <span class="help-block" v-if="crewMedicalError.document_id !== ''">
                                                        <small><strong>{{
                                                            crewMedicalError.document_id
                                                          }}</strong></small>
                                                    </span>
                        </td>
                      </tr>

                                            <tr :class="{'has-error': crewMedicalError.clinic_id}" v-if="crewIsFilipino">
                                                <th>
                                                    <label class="font-weight-bolder text-left form-label-sm"
                                                           for="clinic_id"
                                                    >
                                                        Medical Clinic:
                                                    </label>
                                                </th>
                                                <td>
                                                    <select class="form-control form-control-sm" id="clinic_id"
                                                            :disabled="!editable"
                                                            required
                                                            v-model="crewMedical.clinic_id"
                                                    >
                                                        <option :value="''">--- SELECT CLINIC ---</option>
                                                        <option v-for="clinicKey in clinicKeys"
                                                                :key="clinicKey.id"
                                                                :value="clinicKey.id"
                                                        >{{ clinicKey.name }}</option>
                                                    </select>
                                                    <span class="help-block" v-if="crewMedicalError.clinic_id !== ''">
                                                        <small><strong>{{ crewMedicalError.clinic_id }}</strong></small>
                                                    </span>
                        </td>
                      </tr>

                                            <tr :class="{'has-error': crewMedicalError.other_clinic}" v-else>
                                                <th>
                                                    <label class="font-weight-bolder text-left form-label-sm"
                                                           for="other-clinic"
                                                    >
                                                        Other Clinic:
                                                    </label>
                                                </th>
                                                <td>
                                                    <input type="text" id="other-clinic"
                                                           class="form-control form-control-sm"
                                                           :placeholder="editable ? 'Enter Clinic Name' : 'Not specified'"
                                                           :readonly="!editable"
                                                           required
                                                           v-model="crewMedical.other_clinic"
                                                    >
                                                    <span class="help-block" v-if="crewMedicalError.other_clinic !== ''">
                                                    <small><strong>{{ crewMedicalError.other_clinic }}</strong></small>
                                                </span>
                        </td>
                      </tr>

                      <tr :class="{'has-error': crewMedicalError.fitness_date}">
                        <th>
                          <label class="font-weight-bolder text-left form-label-sm"
                                 for="fitness_date"
                          >
                            Fitness Date:
                          </label>
                        </th>
                        <td>
                          <input type="date" id="fitness_date"
                                 :readonly="!editable"
                                 class="form-control form-control-sm"
                                 v-model="crewMedical.fitness_date"
                          >
                          <span class="help-block" v-if="crewMedicalError.fitness_date !== ''">
                                                            <small><strong>{{ crewMedicalError.fitness_date }}</strong></small>
                                                        </span>
                        </td>
                      </tr>

                                                <tr :class="{'has-error': crewMedicalError.issued_date}">
                                                    <th>
                                                        <label class="font-weight-bolder text-left form-label-sm"
                                                               for="issued_date"
                                                        >
                                                            Issued Date:
                                                        </label>
                                                    </th>
                                                    <td>
                                                        <input type="date" id="issued_date"
                                                               :readonly="!editable"
                                                               required
                                                               class="form-control form-control-sm"
                                                               v-model="crewMedical.issued_date"
                                                        >
                                                        <span class="help-block" v-if="crewMedicalError.issued_date !== ''">
                                                            <small><strong>{{ crewMedicalError.issued_date }}</strong></small>
                                                        </span>
                        </td>
                      </tr>

                                                <tr :class="{'has-error': crewMedicalError.expiry_date}">
                                                    <th>
                                                        <label class="font-weight-bolder text-left form-label-sm"
                                                               for="issued_date"
                                                        >
                                                            Expiry Date:
                                                        </label>
                                                    </th>
                                                    <td>
                                                        <input type="date" id="expiry_date"
                                                               :readonly="!editable"
                                                               class="form-control form-control-sm"
                                                               v-model="crewMedical.expiry_date"
                                                               :required="crewMedical.document_id==25"
                                                        >
                                                        <span class="help-block" v-if="crewMedicalError.expiry_date !== ''">
                                                            <small><strong>{{ crewMedicalError.expiry_date }}</strong></small>
                                                        </span>
                        </td>
                      </tr>

                      <tr :class="{'has-error': crewMedicalError.diagnosis}">
                        <th>
                          <label class="font-weight-bolder text-left form-label-sm"
                                 for="diagnosis"
                          >
                            Diagnosis:
                          </label>
                        </th>
                        <td>
                          <input type="text" id="diagnosis"
                                 :readonly="!editable"
                                 class="form-control form-control-sm"
                                 v-model="crewMedical.diagnosis"
                          >
                          <span class="help-block" v-if="crewMedicalError.diagnosis !== ''">
                                                        <small><strong>{{ crewMedicalError.diagnosis }}</strong></small>
                                                    </span>
                        </td>
                      </tr>

                                                <tr :class="{'has-error': crewMedicalError.medical_recommendation_id}">
                                                    <th>
                                                        <label class="font-weight-bolder text-left form-label-sm"
                                                               for="medical_recommendation_id"
                                                        >
                                                            Recommendation:
                                                        </label>
                                                    </th>
                                                    <td>
                                                        <select class="form-control form-control-sm" id="medical_recommendation_id"
                                                                v-model="crewMedical.medical_recommendation_id"
                                                                required
                                                                :disabled="!editable"
                                                        >
                                                            <option :value="''">--- SELECT RECOMMENDATION ---</option>
                                                            <option v-for="medicalRecommendationKey in medicalRecommendationKeys"
                                                                    :key="medicalRecommendationKey.id"
                                                                    :value="medicalRecommendationKey.id"
                                                            >{{ medicalRecommendationKey.name }}</option>
                                                        </select>
                                                        <span class="help-block" v-if="crewMedicalError.medical_recommendation_id !== ''">
                                                            <small><strong>{{ crewMedicalError.medical_recommendation_id }}</strong></small>
                                                        </span>
                        </td>
                      </tr>

                      <tr>
                        <th>
                          <label class="font-weight-bolder text-left form-label-sm"
                          >
                            HBA Test:
                          </label>
                        </th>
                        <td>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="hba" id="yes" value="1"
                                   v-model="crewMedical.hba_test"
                                   :disabled="!editable"
                            >
                            <label class="form-check-label" for="yes">YES</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="hba" id="no" value="0"
                                   v-model="crewMedical.hba_test"
                                   :disabled="!editable"
                            >
                            <label class="form-check-label" for="no">NO</label>
                          </div>
                        </td>
                      </tr>

                      <tr :class="{'has-error': crewMedicalError.remarks}">
                        <th>
                          <label class="font-weight-bolder text-left form-label-sm"
                                 for="remarks"
                          >
                            Remarks:
                          </label>
                        </th>
                        <td>
                                                    <textarea rows="3" class="form-control" id="remarks"
                                                              v-model="crewMedical.remarks"
                                                              :readonly="!editable"
                                                    ></textarea>
                          <span class="help-block" v-if="crewMedicalError.remarks !== ''">
                                                        <small><strong>{{ crewMedicalError.remarks }}</strong></small>
                                                    </span>
                        </td>
                      </tr>

                      <tr v-if="editable">
                        <th>
                          <label class="font-weight-bolder text-left form-label-sm"
                                 for="remarks"
                          >
                            Upload File:
                          </label>
                        </th>
                        <td>
                          <div class="custom-file">
                            <template id="crewMedicalContainer">
                              <input type="file" class="custom-file-input" id="updatedMedicalFile"
                                     accept="application/pdf">
                            </template>
                            <label class="custom-file-label" for="updatedMedicalFile">Choose file</label>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td></td>
                        <td class="text-right">
                          <template v-if="crew.active == 1 || isSystemAdmin">
                            <button type="submit" class="btn btn-warning btn-sm mr-3 font-weight-bolder"
                                    v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
                              <i class="fas fa-edit"></i>
                              {{ editable ? 'Update' : 'Edit' }}
                            </button>
                          </template>
                          <button class="btn btn-danger btn-sm font-weight-bolder"
                                  v-if="editable"
                                  @click="cancelEdit"
                          >
                            <span class="fas fa-ban"></span>
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </form>

                <div class="col-sm-8 pb-0 bg-lightgray">

                  <iframe :src="blobMedical"
                         id="fileIframe"
                         v-if="blobMedical"
                         height="600" width="955"
                  />
                  <div class="alert alert-warning" role="alert" v-else>
                    NO UPLOADED DOCUMENT
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {dataMixin} from '@/mixins/dataMixin';
import {crewMedicalMixin} from '@/mixins/crewMedicalMixin';
import {gateMixin} from '@/mixins/gateMixin';
import {mapActions, mapGetters} from 'vuex';
import {formMixin} from "@/mixins/formMixin";
import AppLoading from "@/components/elements/AppLoading";
import AddMedical
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/AddMedical";
import MedicalNavigation
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/MedicalNavigation";
import {FileService} from "../../../../../../../services/FileService";

export default {
  name: "MedicalDocument",
  mixins: [vueAppMixin, formMixin, dataMixin, crewMedicalMixin, gateMixin],
  components: {AddMedical, MedicalNavigation, AppLoading},
  data() {
    return {
      medicalId: '',
      crewMedical: {},
      tempCrewMedical: {},
      crewMedicalError: {},
      editable: false,
      blobMedical:'',
    }
  },
  methods: {
    ...mapActions(['getCrewMedicals', 'getMedicalKeys', 'getClinicKeys', 'getMedicalRecommendationKeys', 'updateCrewMedical', 'deleteCrewMedical']),

    async updateMedicalList() {
      let params = {
        crew_id: this.crew.id,
      };
      if (this.medicalId != '') params['document_id'] = this.medicalId;
      this.getCrewMedicals(params);
    },

    async initializeData() {
      await this.updateMedicalList();
      await this.getMedicalKeys();
      await this.getClinicKeys();
      await this.getMedicalRecommendationKeys();
    },

    async confirmUpdateCrewMedical() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let formData = new FormData();
          Object.keys(this.crewMedical).forEach(key => {
            let value = this.crewMedical[key] ? this.crewMedical[key] : '';
            formData.append(key, value);
          });
          formData.append('crew_id', this.crew.id);
          let updatedMedicalFile = document.getElementById('updatedMedicalFile');
          if (updatedMedicalFile.files && updatedMedicalFile.files[0]) {
            let file = updatedMedicalFile.files[0];
            formData.append('updatedMedicalFile', file);
          }
          let updatedCrewMedical = await this.updateCrewMedical(formData);
          if (updatedCrewMedical) {
            if (updatedCrewMedical.errors) {
              this.crewMedicalError = updatedCrewMedical.errors;
            } else {
              this.successAlert('Crew Medical Successfully Added', 'UPDATED');
              this.crewMedicalError = {
                diagnosis: '',
                remarks: '',
                fitness_date: '',
                issued_date: '',
                expiry_date: '',
                hba_test: '',
                document_id: '',
                clinic_id: '',
                other_clinic: '',
                medical_recommendation_id: ''
              }
              this.refreshInputFile('updatedMedicalFile');
              document.getElementById('close-update-crew-medical').click();
            }
          }
        }
      } else {
        this.crewMedical = this.tempCrewMedical;
        this.editable = true;
      }
    },

    cancelEdit() {
      this.tempCrewMedical = this.crewMedical;
      this.crewMedical = this.crewMedicals.find(crewMedical => crewMedical.id == this.crewMedical.id);
      this.editable = false;
    },

   async updateCrewMedicalModal(crewMedical) {
      this.crewMedicalError = {};
      this.crewMedical = Object.assign({}, crewMedical);
      this.tempCrewMedical = Object.assign({}, crewMedical);
      this.crewMedicalId = crewMedical.id;
      this.medicalTitle = crewMedical.name;
      const file  =await this.getCrewMedicalFile(this.crewMedical.id)
      this.blobMedical = file ? FileService.base64FileToBlobUrl(file) : '';
      // this.getCrewDocumentHistory({crewId: this.crew.id, documentId: this.crewDocumentId})
    },

    async confirmDeleteCrewMedical(crewMedicalId) {
      if (await this.confirmDeleteAlert()) {
        let deletedCrewMedical = await this.deleteCrewMedical({id: crewMedicalId});
        if (deletedCrewMedical) {
          if (deletedCrewMedical.errors) {
            return deletedCrewMedical;
          } else {
            this.successAlert('Crew Medical Deleted', 'DELETE');
          }
        }
      }
    },

    selectDocuments(source) {
      this.crewMedicals.forEach(medical => {
        if (medical.hasFile) {
          if (source.target.checked) {
            this.printMultipleParams.selectedCrewDocuments.medicals.push(medical.id);
          } else {
            this.printMultipleParams.selectedCrewDocuments.medicals = this.printMultipleParams.selectedCrewDocuments.medicals.filter(medicalId => {
              medicalId != medical.id
            });
          }
        }
      });
    }

  },

  created() {
    this.initializeData();
  },

  computed: {
    ...mapGetters([
      'medicalKeys',
      'crewMedicals',
      'clinicKeys',
      'medicalRecommendationKeys',
      'crew',
      'crewMedicalFile',
      'printMultipleParams'
    ]),

    allMedicalSelected() {
      let allSelected = true;
      this.crewMedicals.forEach(medical => {
        if (medical.hasFile) {
          if (!this.printMultipleParams.selectedCrewDocuments.medicals.includes(medical.id)) {
            allSelected = false;
          }
        }
      });
      return allSelected;
    }
  }
}
</script>

<style scoped>
* {
  font-family: 'Nunito', sans-serif;
}

.bg-lightgray {
  background: lightgray;
}

.col-table-2 tr td:first-child {
  font-weight: bold;
}

.modal-lg {
  max-width: 1000px;
}

.modal-medical-custom {
  max-width: 1480px !important;
}
</style>
